var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"toggleable":"lg","type":"dark","variant":"dark"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/logo-horizontal.png"),"alt":"Fleet Battle logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }